import { missingText } from "~/lib/centra/utils/missingYarnsCount";

export const textconfig = {
	locationSelector: {
		scandinavia: "Skandinavia",
		eu: "EU",
		other: "Resten av verden",
		search: "Søk etter land",
	},

	plp: {
		garn: {
			titles: [{ name: "Garn", link: "/garn", current: true }],
			heroText:
				"Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
			meta: {
				title: "Garn",
				description: "Garn",
			},
		},
		utstyr: {
			titles: [{ name: "Garn", link: "/garn", current: true }],
			heroText:
				"Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
			meta: {
				title: "Garn",
				description: "Garn",
			},
		},
		oppskrifter: {
			titles: [{ name: "Garn", link: "/garn", current: true }],
			heroText:
				"Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
			meta: {
				title: "Garn",
				description: "Garn",
			},
		},
		hefter: {
			titles: [{ name: "Garn", link: "/garn", current: true }],
			heroText:
				"Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
			meta: {
				title: "Garn",
				description: "Garn",
			},
		},
		outlet: {
			titles: [{ name: "Garn", link: "/garn", current: true }],
			heroText:
				"Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
			meta: {
				title: "Garn",
				description: "Garn",
			},
		},
		strikkepinner: {
			titles: [{ name: "Garn", link: "/garn", current: true }],
			heroText:
				"Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
			meta: {
				title: "Garn",
				description: "Garn",
			},
		},
		pagination: {
			end: {
				title: "Det var slutten.",
				paragraph:
					"... eller, det avhenger av om du foretrekker å starte Nedenfra og opp eller Ovenfra og ned ...",
				buttonLabel: "Opp til toppen",
			},
		},
		filtersLabels: {
			topDown: "Ovenfra og ned",
			bottomUp: "Nedenfra og opp",
		},
	},
	pdp: {
		booklets: {
			previewBtn: "Bla i heftet",
			otherRecipes: "Oppskrifter i dette heftet",
		},
		recipes: {
			otherBooklets: "Andre oppskrifter i samme hefte",
			format: {
				digital: "Digitalt",
				paper: "Papir",
				multi: "Digitalt & Papir",
			},
		},
		relatedProducts: "Relaterte produkter",
	},
	account: {
		heroText: {
			prefix: "Hei, ",
			suffix: "!",
		},
		heroDescription:
			"Velkommen til siden din, her kan du endre kontaktinformasjon, adresser og se tidligere bestillinger.",
		name: "Kontodetaljer",
		logOutLabel: "Log ut",
		customerCare: {
			name: "Kundeservice",
			title: "Kundeservice",
			subtitle: "Trenger du å ta kontakt med oss?",
			description:
				"Hvis du har noen spørsmål relatert til din ordre, våre produkter eller vår nettside, vennligst ring eller send oss en email.",
			call: "Ring os på: +47 923 23 323",
			openingHoursLabel: "Vår Kundeservicelinje er åpen alle virkedager mellom:",
			openingHours: "09:00-12:00 & 12:30-17:00",
		},
		orderHistory: {
			name: "Mine Ordre",
			noOrdersMessage: "Du har ingen ordre",
		},
		recipes: {
			name: "Mine Oppskrifter",
			noRecipesMessage: "Du har ingen oppskrifter",
			noPdfMessage: "Ingen PDF tilgjengelig. Kontakt nettbutikk@raumaull.no",
			menus: ["Oppskrift", "Nummer", "Navn", "Last ned"],
			downloadInfo: "last updated: ",
			orderStatus: {
				pending: "Venter",
				confirmed: "Bekreftet",
				processing: "Sendes",
				completed: "Levert",
				archived: "Arkivert",
				canceled: "Kansellert",
				incomplete: "Ufullstendig",
			},
		},
		address: {
			name: "Mine Adresser",
		},
		password: {
			name: "Passord",
		},
	},
	changePassword: {
		title: "Passord",
		subtitle: "Bytt passord",
	},
	recoverPassword: {
		title: "Gjenopprett ditt passord",
		backButtonLabel: "Tilbake til innloging",
	},
	login: {
		title: "Logg inn til din konto",
		subtitle: "Ikke registrert?",
		registerButtonLabel: "Register deg",
		buttonLabel: "Logg inn",
		forgotPasswordLabel: "Glemt passord?",
	},
	register: {
		title: "Registrer",
		subtitle: "Har du allerede en konto?",
		loginButtonLabel: "Logg inn",
		buttonLabel: "Registrer deg",
	},
	buttons: {
		readMore: "Les mer",
	},

	cart: {
		singleRecipe: "Oppskrift",
		multipleRecipes: "Oppskrifter",
		singleBooklet: "Hefte",
		multipleBooklets: "Hefter",
		singleYarn: "Nøste",
		multipleYarns: "Nøster",
		singleItem: "Produkt",
		multipleItems: "Produkter",
		yarnWarning: missingText,
	},

	display: {
		tabs: {
			all: "Alle",
			yarn: "Garn",
			booklet: "Hefter",
			recipe: "Oppskrifter",
			accessory: "Tilbehør",
		},
	},

	checkout: {
		summary: {
			title: "Ordrebekreftelse",
			failed: {
				title: "Noe gikk galt",
				message: "Din betaling ble avbrutt. Vennligst prøv igjen, eller kontakt oss.",
				link: "Trykk her for å prøve igjen",
			},
			notFound: {
				title: "Vi kunne ikke finne din ordre",
				message: "Vennligst sjekk din e-post for bekreftelse",
			},
			success: {
				title: "Takk for din ordre",
				goToOrders: "Gå til mine ordre.",
				message: "En bekreftelse er sendt på e-post til ",
				shipping: "Frakt",
				orderInfo: {
					title: "Ordre informasjon",
					orderNumber: "Ordrenummer",
					orderDate: "Ordredato",
					orderStatus: "Ordrestatus",
				},
			},
		},
	},

	footer: {
		newsletter: {
			placeholder: "E-post",
			buttonText: "Ja, takk",
			buttonLoadingText: "Sender...",
			label: "Søk",
			errors: {
				missingEmailMessage: "Vennligst legg inn en e-postadresse.",
				invalidEmailMessage: "Vennligst legg inn en gyldig e-postadresse.",
				successMessage: "Takk for at du meldte deg på!",
				errorMessage: "Noe gikk galt. Vennligst prøv igjen senere.",
			},
		},
	},
} as const;
